<template>
<div class="card card-custom gutter-b card-stretch ">
    <div class="card-body">
        <div class="d-flex mb-8">
            <!--begin::Pic-->
            <div class="flex-shrink-0 mr-7">
                <div class="symbol symbol-50 symbol-lg-120">
                    <img alt="Pic" src="https://th.bing.com/th/id/OIP.MbPZ-r1B8OR2jBiUU8TylAHaE8">
                </div>
            </div>
            <!--end::Pic-->
            <!--begin: Info-->
            <div class="flex-grow-1">
                <!--begin::Title-->
                <div class="d-flex align-items-center justify-content-between flex-wrap">
                    <!--begin::User-->
                    <div class="mr-3">
                        <div class="d-flex align-items-center mr-3">
                            <!--begin::Name-->
                            <a class="d-flex align-items-center text-dark text-hover-primary font-size-h2 font-weight-bolder mr-3">{{eventInfo.name}}</a>
                            <!--end::Name-->

                        </div>
                        <!--begin::Contacts-->
                        <div class="d-flex flex-wrap my-2">
                            <div class="text-muted font-weight-bolder mr-lg-8 mr-5 mb-lg-0 mb-2">
                                <span class="svg-icon svg-icon-md svg-icon-gray-500 mr-1">
                                    <!--begin::Svg Icon | path:/metronic/theme/html/demo2/dist/assets/media/svg/icons/Communication/Mail-notification.svg-->
                                    <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
                                        <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                                            <rect x="0" y="0" width="24" height="24"></rect>
                                            <path d="M21,12.0829584 C20.6747915,12.0283988 20.3407122,12 20,12 C16.6862915,12 14,14.6862915 14,18 C14,18.3407122 14.0283988,18.6747915 14.0829584,19 L5,19 C3.8954305,19 3,18.1045695 3,17 L3,8 C3,6.8954305 3.8954305,6 5,6 L19,6 C20.1045695,6 21,6.8954305 21,8 L21,12.0829584 Z M18.1444251,7.83964668 L12,11.1481833 L5.85557487,7.83964668 C5.4908718,7.6432681 5.03602525,7.77972206 4.83964668,8.14442513 C4.6432681,8.5091282 4.77972206,8.96397475 5.14442513,9.16035332 L11.6444251,12.6603533 C11.8664074,12.7798822 12.1335926,12.7798822 12.3555749,12.6603533 L18.8555749,9.16035332 C19.2202779,8.96397475 19.3567319,8.5091282 19.1603533,8.14442513 C18.9639747,7.77972206 18.5091282,7.6432681 18.1444251,7.83964668 Z" fill="#000000"></path>
                                            <circle fill="#000000" opacity="0.3" cx="19.5" cy="17.5" r="2.5"></circle>
                                        </g>
                                    </svg>
                                    <!--end::Svg Icon-->
                                </span>{{personasList.length}} Registrados</div>
                            <!--<div class="text-muted font-weight-bolder mr-lg-8 mr-5 mb-lg-0 mb-2">
                                <span class="svg-icon svg-icon-md svg-icon-gray-500 mr-1">

                                    <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
                                        <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                                            <mask fill="white">
                                                <use xlink:href="#path-1"></use>
                                            </mask>
                                            <g></g>
                                            <path d="M7,10 L7,8 C7,5.23857625 9.23857625,3 12,3 C14.7614237,3 17,5.23857625 17,8 L17,10 L18,10 C19.1045695,10 20,10.8954305 20,12 L20,18 C20,19.1045695 19.1045695,20 18,20 L6,20 C4.8954305,20 4,19.1045695 4,18 L4,12 C4,10.8954305 4.8954305,10 6,10 L7,10 Z M12,5 C10.3431458,5 9,6.34314575 9,8 L9,10 L15,10 L15,8 C15,6.34314575 13.6568542,5 12,5 Z" fill="#000000"></path>
                                        </g>
                                    </svg>
                                </span>0 Clubes registrados</div>-->
                            <div v-if="eventInfo.register == '1'" class="bg-success text-white border border-success rounded px-4">
                                Inscripciones habilitadas
                            </div>
                            <div v-else class="bg-danger text-white border border-danger rounded px-4">
                                Inscripciones Finalizadas
                            </div>
                        </div>
                        <!--end::Contacts-->
                    </div>
                    <!--begin::User-->
                    <!--begin::Actions-->

                    <!--end::Actions-->
                </div>
                <!--end::Title-->
                <!--begin::Content-->
                <div class="d-flex align-items-center flex-wrap justify-content-between">
                    <!--begin::Description-->
                    <div class="flex-grow-1 font-weight-bold text-dark-50 py-2 py-lg-2 mr-5">El siguiente evento tiene como finalizad destacar el deporte...</div>
                    <!--end::Description-->
                    <!--begin::Progress-->

                    <!--end::Progress-->
                </div>
                <!--end::Content-->
            </div>
            <!--end::Info-->
        </div>

        <div class="page-topbar border-top border-bottom py-4">
            <div class="title">
                <ul class="nav nav-light-danger nav-bold nav-pills">
                    <li class="nav-item">
                        <div class="nav-link btn" @click="setActive('tab1'), title='Deportista'" :class="{ active: isActive('tab1') }">
                            <span class="nav-icon">
                                <span class="svg-icon svg-icon-primary svg-icon-2x">
                                    <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
                                        <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                                            <polygon points="0 0 24 0 24 24 0 24" />
                                            <rect fill="#000000" opacity="0.3" x="2" y="3" width="7" height="14" rx="1" />
                                            <path d="M16.6236387,13.0538007 C18.8273383,13.8579339 20.1826034,13.7956508 21,14 C21.5844894,14.1461224 22.1049236,14.4525789 22.5613025,14.9193695 C22.8220479,15.1860635 23.0030223,15.5203564 23.0837834,15.8844876 C23.3229559,16.9628548 22.6426541,18.0309317 21.5642858,18.2700997 C20.2740329,18.5562665 18.7433451,18.7531138 16.9722222,18.8606416 C13.9910551,19.0416332 8.86226533,19.0463278 1.5858528,18.8747253 C1.26005876,18.867042 0.999953435,18.6007302 0.999953435,18.2748455 L1,18.2748455 C1,15.4124758 1,13.3451074 1,12.0727406 C5.24980707,11.6622656 8.09783699,10.5071287 9.54408978,8.60732991 C9.56481367,8.58010699 9.58782802,8.55470651 9.6128812,8.53140618 C9.85553488,8.30572983 10.2351914,8.31949268 10.4608598,8.56215378 C10.8762386,9.00878105 11.2674202,9.41538104 11.6344046,9.78195376 C11.6101853,9.81416566 11.5876475,9.84819014 11.5669873,9.8839746 L10.0669873,12.4820508 C9.79084492,12.9603434 9.95472008,13.5719338 10.4330127,13.8480762 C10.9113053,14.1242186 11.5228957,13.9603434 11.7990381,13.4820508 L13.1335582,11.1705941 C13.630492,11.5858319 14.0581948,11.8865474 14.4166667,12.0727406 C14.5381042,12.1358162 14.6576898,12.1965218 14.7754507,12.2549561 L14.0669873,13.4820508 C13.7908449,13.9603434 13.9547201,14.5719338 14.4330127,14.8480762 C14.9113053,15.1242186 15.5228957,14.9603434 15.7990381,14.4820508 L16.6236387,13.0538007 Z" fill="#000000" />
                                        </g>
                                    </svg>
                                </span>
                            </span>
                            <span class="nav-text">Deportistas</span>
                        </div>
                    </li>
                    <li class="nav-item">
                        <div class="nav-link btn" @click="setActive('tab2'), title='Oficial'" :class="{ active: isActive('tab2') }">
                            <span class="nav-icon">
                                <span class="svg-icon svg-icon-primary svg-icon-2x">
                                    <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
                                        <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                                            <rect x="0" y="0" width="24" height="24" />
                                            <path d="M8,3 L8,3.5 C8,4.32842712 8.67157288,5 9.5,5 L14.5,5 C15.3284271,5 16,4.32842712 16,3.5 L16,3 L18,3 C19.1045695,3 20,3.8954305 20,5 L20,21 C20,22.1045695 19.1045695,23 18,23 L6,23 C4.8954305,23 4,22.1045695 4,21 L4,5 C4,3.8954305 4.8954305,3 6,3 L8,3 Z" fill="#000000" opacity="0.3" />
                                            <path d="M11,2 C11,1.44771525 11.4477153,1 12,1 C12.5522847,1 13,1.44771525 13,2 L14.5,2 C14.7761424,2 15,2.22385763 15,2.5 L15,3.5 C15,3.77614237 14.7761424,4 14.5,4 L9.5,4 C9.22385763,4 9,3.77614237 9,3.5 L9,2.5 C9,2.22385763 9.22385763,2 9.5,2 L11,2 Z" fill="#000000" />
                                            <rect fill="#000000" opacity="0.3" x="7" y="10" width="5" height="2" rx="1" />
                                            <rect fill="#000000" opacity="0.3" x="7" y="14" width="9" height="2" rx="1" />
                                        </g>
                                    </svg>
                                </span>
                            </span>
                            <span class="nav-text">Oficiales</span>
                        </div>
                    </li>
                    <li class="nav-item">
                        <div class="nav-link btn" @click="setActive('tab3')" :class="{ active: isActive('tab3') }">
                            <span class="nav-icon">
                                <span class="svg-icon svg-icon-primary svg-icon-2x">
                                    <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
                                        <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                                            <rect x="0" y="0" width="24" height="24" />
                                            <path d="M8,3 L8,3.5 C8,4.32842712 8.67157288,5 9.5,5 L14.5,5 C15.3284271,5 16,4.32842712 16,3.5 L16,3 L18,3 C19.1045695,3 20,3.8954305 20,5 L20,21 C20,22.1045695 19.1045695,23 18,23 L6,23 C4.8954305,23 4,22.1045695 4,21 L4,5 C4,3.8954305 4.8954305,3 6,3 L8,3 Z" fill="#000000" opacity="0.3" />
                                            <path d="M11,2 C11,1.44771525 11.4477153,1 12,1 C12.5522847,1 13,1.44771525 13,2 L14.5,2 C14.7761424,2 15,2.22385763 15,2.5 L15,3.5 C15,3.77614237 14.7761424,4 14.5,4 L9.5,4 C9.22385763,4 9,3.77614237 9,3.5 L9,2.5 C9,2.22385763 9.22385763,2 9.5,2 L11,2 Z" fill="#000000" />
                                            <rect fill="#000000" opacity="0.3" x="7" y="10" width="5" height="2" rx="1" />
                                            <rect fill="#000000" opacity="0.3" x="7" y="14" width="9" height="2" rx="1" />
                                        </g>
                                    </svg>
                                </span>
                            </span>
                            <span class="nav-text">Documentos</span>
                        </div>
                    </li>
                    <li class="nav-item">
                        <div class="nav-link btn" @click="setActive('tab4')" :class="{ active: isActive('tab4') }">
                            <span class="nav-icon">
                                <span class="svg-icon svg-icon-primary svg-icon-2x">
                                    <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
                                        <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                                            <rect x="0" y="0" width="24" height="24" />
                                            <path d="M8,3 L8,3.5 C8,4.32842712 8.67157288,5 9.5,5 L14.5,5 C15.3284271,5 16,4.32842712 16,3.5 L16,3 L18,3 C19.1045695,3 20,3.8954305 20,5 L20,21 C20,22.1045695 19.1045695,23 18,23 L6,23 C4.8954305,23 4,22.1045695 4,21 L4,5 C4,3.8954305 4.8954305,3 6,3 L8,3 Z" fill="#000000" opacity="0.3" />
                                            <path d="M11,2 C11,1.44771525 11.4477153,1 12,1 C12.5522847,1 13,1.44771525 13,2 L14.5,2 C14.7761424,2 15,2.22385763 15,2.5 L15,3.5 C15,3.77614237 14.7761424,4 14.5,4 L9.5,4 C9.22385763,4 9,3.77614237 9,3.5 L9,2.5 C9,2.22385763 9.22385763,2 9.5,2 L11,2 Z" fill="#000000" />
                                            <rect fill="#000000" opacity="0.3" x="7" y="10" width="5" height="2" rx="1" />
                                            <rect fill="#000000" opacity="0.3" x="7" y="14" width="9" height="2" rx="1" />
                                        </g>
                                    </svg>
                                </span>
                            </span>
                            <span class="nav-text">Avisos</span>
                        </div>
                    </li>
                </ul>
            </div>
            <div class="d-flex align-items-center flex-wrap" v-if="activeItem=='tab1' || activeItem=='tab2'">
                <el-select v-if="activeItem=='tab2'" v-model="record_type" class="mr-2" placeholder="Tipo de oficial" size="medium">
                    <el-option v-for="item in oficialType" :key="item.id" :label="item.name" :value="item.id"></el-option>
                </el-select>
                <div v-if="eventInfo.register == '1'" @click="openDialogSelection" class="btn btn-sm btn-danger mr-2">
                    <span class="svg-icon svg-icon-primary svg-icon-2x">
                        <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
                            <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                                <polygon points="0 0 24 0 24 24 0 24" />
                                <path d="M18,8 L16,8 C15.4477153,8 15,7.55228475 15,7 C15,6.44771525 15.4477153,6 16,6 L18,6 L18,4 C18,3.44771525 18.4477153,3 19,3 C19.5522847,3 20,3.44771525 20,4 L20,6 L22,6 C22.5522847,6 23,6.44771525 23,7 C23,7.55228475 22.5522847,8 22,8 L20,8 L20,10 C20,10.5522847 19.5522847,11 19,11 C18.4477153,11 18,10.5522847 18,10 L18,8 Z M9,11 C6.790861,11 5,9.209139 5,7 C5,4.790861 6.790861,3 9,3 C11.209139,3 13,4.790861 13,7 C13,9.209139 11.209139,11 9,11 Z" fill="#000000" fill-rule="nonzero" opacity="0.3" />
                                <path d="M0.00065168429,20.1992055 C0.388258525,15.4265159 4.26191235,13 8.98334134,13 C13.7712164,13 17.7048837,15.2931929 17.9979143,20.2 C18.0095879,20.3954741 17.9979143,21 17.2466999,21 C13.541124,21 8.03472472,21 0.727502227,21 C0.476712155,21 -0.0204617505,20.45918 0.00065168429,20.1992055 Z" fill="#000000" fill-rule="nonzero" />
                            </g>
                        </svg>
                    </span>
                    Registrar
                </div>
                <el-tooltip class="item" effect="dark" content="Finalizar inscripción" placement="top-start">
                    <div class="btn btn-light mr-2 px-2 py-2" @click="openDialogFinalizar">
                        <span class="svg-icon font-weight-bold text-dark-75 mr-0">
                            <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
                                <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                                    <rect x="0" y="0" width="24" height="24" />
                                    <path d="M21.4451171,17.7910156 C21.4451171,16.9707031 21.6208984,13.7333984 19.0671874,11.1650391 C17.3484374,9.43652344 14.7761718,9.13671875 11.6999999,9 L11.6999999,4.69307548 C11.6999999,4.27886191 11.3642135,3.94307548 10.9499999,3.94307548 C10.7636897,3.94307548 10.584049,4.01242035 10.4460626,4.13760526 L3.30599678,10.6152626 C2.99921905,10.8935795 2.976147,11.3678924 3.2544639,11.6746702 C3.26907199,11.6907721 3.28437331,11.7062312 3.30032452,11.7210037 L10.4403903,18.333467 C10.7442966,18.6149166 11.2188212,18.596712 11.5002708,18.2928057 C11.628669,18.1541628 11.6999999,17.9721616 11.6999999,17.7831961 L11.6999999,13.5 C13.6531249,13.5537109 15.0443703,13.6779456 16.3083984,14.0800781 C18.1284272,14.6590944 19.5349747,16.3018455 20.5280411,19.0083314 L20.5280247,19.0083374 C20.6363903,19.3036749 20.9175496,19.5 21.2321404,19.5 L21.4499999,19.5 C21.4499999,19.0068359 21.4451171,18.2255859 21.4451171,17.7910156 Z" fill="#000000" fill-rule="nonzero" transform="translate(12.254964, 11.721538) scale(-1, 1) translate(-12.254964, -11.721538) " />
                                </g>
                            </svg>
                        </span>
                        Finalizar
                    </div>
                </el-tooltip>

                <el-tooltip class="item" effect="dark" content="Descargar consolidado" placement="top-start">
                    <div class="btn btn-primary mr-2 px-2 py-2" @click="downloadConsolidate">
                        <span class="svg-icon font-weight-bold text-dark-75 mr-0">
                            <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
                                <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                                    <rect x="0" y="0" width="24" height="24" />
                                    <path d="M21.4451171,17.7910156 C21.4451171,16.9707031 21.6208984,13.7333984 19.0671874,11.1650391 C17.3484374,9.43652344 14.7761718,9.13671875 11.6999999,9 L11.6999999,4.69307548 C11.6999999,4.27886191 11.3642135,3.94307548 10.9499999,3.94307548 C10.7636897,3.94307548 10.584049,4.01242035 10.4460626,4.13760526 L3.30599678,10.6152626 C2.99921905,10.8935795 2.976147,11.3678924 3.2544639,11.6746702 C3.26907199,11.6907721 3.28437331,11.7062312 3.30032452,11.7210037 L10.4403903,18.333467 C10.7442966,18.6149166 11.2188212,18.596712 11.5002708,18.2928057 C11.628669,18.1541628 11.6999999,17.9721616 11.6999999,17.7831961 L11.6999999,13.5 C13.6531249,13.5537109 15.0443703,13.6779456 16.3083984,14.0800781 C18.1284272,14.6590944 19.5349747,16.3018455 20.5280411,19.0083314 L20.5280247,19.0083374 C20.6363903,19.3036749 20.9175496,19.5 21.2321404,19.5 L21.4499999,19.5 C21.4499999,19.0068359 21.4451171,18.2255859 21.4451171,17.7910156 Z" fill="#000000" fill-rule="nonzero" transform="translate(12.254964, 11.721538) scale(-1, 1) translate(-12.254964, -11.721538) " />
                                </g>
                            </svg>
                        </span>
                        Consolidado
                    </div>
                </el-tooltip>

                <el-tooltip class="item" effect="dark" content="Descargar nominal de participación" placement="top-start">
                    <div class="btn btn-light mr-2 py-2 d-none">
                        <span class="svg-icon font-weight-bold text-dark-75 mx-0">
                            <svg data-v-3022895a="" data-v-7c235ad9="" aria-hidden="true" focusable="false" data-prefix="fal" data-icon="download" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" class="svg-inline--fa fa-download fa-w-16">
                                <path data-v-3022895a="" data-v-7c235ad9="" fill="currentColor" d="M452 432c0 11-9 20-20 20s-20-9-20-20 9-20 20-20 20 9 20 20zm-84-20c-11 0-20 9-20 20s9 20 20 20 20-9 20-20-9-20-20-20zm144-48v104c0 24.3-19.7 44-44 44H44c-24.3 0-44-19.7-44-44V364c0-24.3 19.7-44 44-44h99.4L87 263.6c-25.2-25.2-7.3-68.3 28.3-68.3H168V40c0-22.1 17.9-40 40-40h96c22.1 0 40 17.9 40 40v155.3h52.7c35.6 0 53.4 43.1 28.3 68.3L368.6 320H468c24.3 0 44 19.7 44 44zm-261.7 17.7c3.1 3.1 8.2 3.1 11.3 0L402.3 241c5-5 1.5-13.7-5.7-13.7H312V40c0-4.4-3.6-8-8-8h-96c-4.4 0-8 3.6-8 8v187.3h-84.7c-7.1 0-10.7 8.6-5.7 13.7l140.7 140.7zM480 364c0-6.6-5.4-12-12-12H336.6l-52.3 52.3c-15.6 15.6-41 15.6-56.6 0L175.4 352H44c-6.6 0-12 5.4-12 12v104c0 6.6 5.4 12 12 12h424c6.6 0 12-5.4 12-12V364z" class=""></path>
                            </svg>
                        </span>
                    </div>
                </el-tooltip>
                <div class="d-flex align-items-center position-relative mr-2">
                    <span class="svg-icon svg-icon-1 position-absolute ml-3">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                            <rect opacity="0.5" x="17.0365" y="15.1223" width="8.15546" height="2" rx="1" transform="rotate(45 17.0365 15.1223)" fill="black"></rect>
                            <path d="M11 19C6.55556 19 3 15.4444 3 11C3 6.55556 6.55556 3 11 3C15.4444 3 19 6.55556 19 11C19 15.4444 15.4444 19 11 19ZM11 5C7.53333 5 5 7.53333 5 11C5 14.4667 7.53333 17 11 17C14.4667 17 17 14.4667 17 11C17 7.53333 14.4667 5 11 5Z" fill="black"></path>
                        </svg>
                    </span>
                    <input type="text" class="form-control form-control-solid w-200px pl-12" :placeholder="'Buscar en ...'">
                </div>
            </div>
        </div>

        <div class="tab-content py-3">
            <div class="tab-pane fade" :class="{ 'active show': isActive('tab1') }" id="tab1">
                <el-table :data="personasList" highlight-current-row>
                    <el-table-column prop="code" label="Código"></el-table-column>
                    <el-table-column prop="firstname" label="Nombre"></el-table-column>
                    <el-table-column prop="lastname" label="Apellido paterno"></el-table-column>
                    <el-table-column prop="surname" label="Apellido Materno"></el-table-column>
                    <el-table-column prop="modality" label="Modalidad"></el-table-column>
                    <el-table-column prop="division" label="División"></el-table-column>
                    <el-table-column prop="peso" label="SubDivisión"></el-table-column>
                    <el-table-column label="Estado">
                        <template #default="scope">
                            <span class="badge badge-light" v-if="scope.row.checkdoc == '0'">Borrador</span>
                            <span class="badge badge-light-warning" v-if="scope.row.checkdoc == '3'">Enviado</span>

                        </template>
                    </el-table-column>
                    <el-table-column label="Opciones">
                        <template #default="scope">
                            <!--<span class="svg-icon svg-icon-primary svg-icon-2x mr-2" @click="eddiItem(scope.row)">
                                <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
                                    <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                                        <rect x="0" y="0" width="24" height="24" />
                                        <path d="M12.2674799,18.2323597 L12.0084872,5.45852451 C12.0004303,5.06114792 12.1504154,4.6768183 12.4255037,4.38993949 L15.0030167,1.70195304 L17.5910752,4.40093695 C17.8599071,4.6812911 18.0095067,5.05499603 18.0083938,5.44341307 L17.9718262,18.2062508 C17.9694575,19.0329966 17.2985816,19.701953 16.4718324,19.701953 L13.7671717,19.701953 C12.9505952,19.701953 12.2840328,19.0487684 12.2674799,18.2323597 Z" fill="#000000" fill-rule="nonzero" transform="translate(14.701953, 10.701953) rotate(-135.000000) translate(-14.701953, -10.701953) " />
                                        <path d="M12.9,2 C13.4522847,2 13.9,2.44771525 13.9,3 C13.9,3.55228475 13.4522847,4 12.9,4 L6,4 C4.8954305,4 4,4.8954305 4,6 L4,18 C4,19.1045695 4.8954305,20 6,20 L18,20 C19.1045695,20 20,19.1045695 20,18 L20,13 C20,12.4477153 20.4477153,12 21,12 C21.5522847,12 22,12.4477153 22,13 L22,18 C22,20.209139 20.209139,22 18,22 L6,22 C3.790861,22 2,20.209139 2,18 L2,6 C2,3.790861 3.790861,2 6,2 L12.9,2 Z" fill="#000000" fill-rule="nonzero" opacity="0.3" />
                                    </g>
                                </svg>
                            </span>-->
                            <span v-if="scope.row.checkdoc == '0'" class="svg-icon svg-icon-primary svg-icon-2x" @click="deleteItem(scope.row)">
                                <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
                                    <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                                        <rect x="0" y="0" width="24" height="24" />
                                        <path d="M6,8 L18,8 L17.106535,19.6150447 C17.04642,20.3965405 16.3947578,21 15.6109533,21 L8.38904671,21 C7.60524225,21 6.95358004,20.3965405 6.89346498,19.6150447 L6,8 Z M8,10 L8.45438229,14.0894406 L15.5517885,14.0339036 L16,10 L8,10 Z" fill="#000000" fill-rule="nonzero" />
                                        <path d="M14,4.5 L14,3.5 C14,3.22385763 13.7761424,3 13.5,3 L10.5,3 C10.2238576,3 10,3.22385763 10,3.5 L10,4.5 L5.5,4.5 C5.22385763,4.5 5,4.72385763 5,5 L5,5.5 C5,5.77614237 5.22385763,6 5.5,6 L18.5,6 C18.7761424,6 19,5.77614237 19,5.5 L19,5 C19,4.72385763 18.7761424,4.5 18.5,4.5 L14,4.5 Z" fill="#000000" opacity="0.3" />
                                    </g>
                                </svg>
                            </span>

                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div class="tab-pane fade" :class="{ 'active show': isActive('tab2') }" id="tab2">
                <el-table :data="personasList" highlight-current-row>
                    <el-table-column prop="code" label="Código"></el-table-column>
                    <el-table-column prop="firstname" label="Nombre"></el-table-column>
                    <el-table-column prop="lastname" label="Apellido paterno"></el-table-column>
                    <el-table-column prop="surname" label="Apellido Materno"></el-table-column>
                    <el-table-column prop="nfunction" label="Función"></el-table-column>
                    <el-table-column label="Estado">
                        <template #default="scope">
                            <span class="badge badge-light" v-if="scope.row.checkdoc == '0'">Borrador</span>
                            <span class="badge badge-light-warning" v-if="scope.row.checkdoc == '3'">Enviado</span>

                        </template>
                    </el-table-column>
                    <el-table-column label="Opciones">
                        <template #default="scope">
                            <!--<span class="svg-icon svg-icon-primary svg-icon-2x mr-2" @click="eddiItem(scope.row)">
                                <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
                                    <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                                        <rect x="0" y="0" width="24" height="24" />
                                        <path d="M12.2674799,18.2323597 L12.0084872,5.45852451 C12.0004303,5.06114792 12.1504154,4.6768183 12.4255037,4.38993949 L15.0030167,1.70195304 L17.5910752,4.40093695 C17.8599071,4.6812911 18.0095067,5.05499603 18.0083938,5.44341307 L17.9718262,18.2062508 C17.9694575,19.0329966 17.2985816,19.701953 16.4718324,19.701953 L13.7671717,19.701953 C12.9505952,19.701953 12.2840328,19.0487684 12.2674799,18.2323597 Z" fill="#000000" fill-rule="nonzero" transform="translate(14.701953, 10.701953) rotate(-135.000000) translate(-14.701953, -10.701953) " />
                                        <path d="M12.9,2 C13.4522847,2 13.9,2.44771525 13.9,3 C13.9,3.55228475 13.4522847,4 12.9,4 L6,4 C4.8954305,4 4,4.8954305 4,6 L4,18 C4,19.1045695 4.8954305,20 6,20 L18,20 C19.1045695,20 20,19.1045695 20,18 L20,13 C20,12.4477153 20.4477153,12 21,12 C21.5522847,12 22,12.4477153 22,13 L22,18 C22,20.209139 20.209139,22 18,22 L6,22 C3.790861,22 2,20.209139 2,18 L2,6 C2,3.790861 3.790861,2 6,2 L12.9,2 Z" fill="#000000" fill-rule="nonzero" opacity="0.3" />
                                    </g>
                                </svg>
                            </span>-->
                            <span v-if="scope.row.checkdoc == '0'" class="svg-icon svg-icon-primary svg-icon-2x" @click="deleteItem(scope.row)">
                                <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
                                    <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                                        <rect x="0" y="0" width="24" height="24" />
                                        <path d="M6,8 L18,8 L17.106535,19.6150447 C17.04642,20.3965405 16.3947578,21 15.6109533,21 L8.38904671,21 C7.60524225,21 6.95358004,20.3965405 6.89346498,19.6150447 L6,8 Z M8,10 L8.45438229,14.0894406 L15.5517885,14.0339036 L16,10 L8,10 Z" fill="#000000" fill-rule="nonzero" />
                                        <path d="M14,4.5 L14,3.5 C14,3.22385763 13.7761424,3 13.5,3 L10.5,3 C10.2238576,3 10,3.22385763 10,3.5 L10,4.5 L5.5,4.5 C5.22385763,4.5 5,4.72385763 5,5 L5,5.5 C5,5.77614237 5.22385763,6 5.5,6 L18.5,6 C18.7761424,6 19,5.77614237 19,5.5 L19,5 C19,4.72385763 18.7761424,4.5 18.5,4.5 L14,4.5 Z" fill="#000000" opacity="0.3" />
                                    </g>
                                </svg>
                            </span>

                        </template>
                    </el-table-column>
                </el-table>




               <!-- <div class="alert alert-custom alert-light-danger fade show mb-5" role="alert">
                    <div class="alert-icon">
                        <i class="flaticon-warning"></i>
                    </div>
                    <div class="alert-text">No se tiene información de oficiales por el momento!</div>
                    <div class="alert-close">
                        <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                            <span aria-hidden="true">
                                <i class="ki ki-close"></i>
                            </span>
                        </button>
                    </div>
                </div>-->

            </div>
            <div class="tab-pane fade py-4" :class="{ 'active show': isActive('tab3') }" id="tab3">

                <div v-if="documentList.length==0" class="alert alert-custom alert-light-danger fade show mb-5" role="alert">
                    <div class="alert-icon">
                        <i class="flaticon-warning"></i>
                    </div>
                    <div class="alert-text">No se tiene documentos por el momento!</div>
                    <div class="alert-close">
                        <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                            <span aria-hidden="true">
                                <i class="ki ki-close"></i>
                            </span>
                        </button>
                    </div>
                </div>
                <el-table v-else :data="documentList" highlight-current-row>
                    <el-table-column prop="name" label="Descripción"></el-table-column>
                    <el-table-column label="Opción">
                        <template #default="scope">
                            <a :href="scope.row.url" target="_blank" type="primary">Descargar</a>
                        </template>
                    </el-table-column>
                </el-table>

            </div>
            <div class="tab-pane fade py-4" :class="{ 'active show': isActive('tab4') }" id="tab4">
                <div class="alert alert-custom alert-light-danger fade show mb-5" role="alert">
                    <div class="alert-icon">
                        <i class="flaticon-warning"></i>
                    </div>
                    <div class="alert-text">No se tiene avisos por el momento!</div>
                    <div class="alert-close">
                        <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                            <span aria-hidden="true">
                                <i class="ki ki-close"></i>
                            </span>
                        </button>
                    </div>
                </div>
            </div>

        </div>

    </div>
    <DialogSelectionPerson :visible.sync="open_dialog_selection" :title="title" :record_type="record_type" @openDialogRegister="openDialogRegister">

    </DialogSelectionPerson>

    <DialogRegister :visible.sync="open_dialog_register" :record_type="record_type" :personInfo="personInfo" @listParticipantes="listParticipantes" :slug="slug" :eventInfo="eventInfo">

    </DialogRegister>

    <el-dialog :visible="open_dialog_finalizar" :title="'Finalizar inscripción'" width="500px" :close-on-click-modal="false" :close-on-press-escape="false" :show-close="false" top="5vh">
        <el-alert title="Para finalizar la inscripión es necesario registrar a todos los deportistas y oficiales que participarán en el evento, así mismo adjuntar un único archivo que contenga el ó los vouchers de pago (Los pagos deben ser realizados en un solo deposito por institución, Solo es necesario que se adjunte el voucher en una ficha)" type="success" :closable="false">
        </el-alert>
        <el-upload class="upload-demo text-center mt-6" drag 
        :headers="headers" name="file"
        action="https://fdptkd.perufedup.com/api/voucher/upload"
        accept=".jpg,.png,.pdf" :data="{idevent: this.eventInfo.idevent}" 
        :show-file-list="false" 
        :before-upload="FilbeforeAvatarUpload" :on-success="FilhandleAvatarSuccess" 
        :on-error="FilhandleAvatarError">
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">Suelta tu archivo aquí o <em>haz clic para cargar</em></div>
            <div slot="tip" class="el-upload__tip">Solo archivos jpg/png/pdf con un tamaño menor de 1MB</div>
        </el-upload>
        <div slot="footer" class="dialog-footer">
            <el-button size="small" class="" @click="onClose">Cancelar</el-button>

            <el-button type="primary" size="small" icon="el-icon-info" class="mb-1" @click="onClose">Finalizar</el-button>

        </div>
    </el-dialog>

</div>
</template>

<script>
import {
    mapGetters
} from "vuex";

import code from "@/core/config/error";

//services
import evntsService from "@/core/services/events.service"
import acrService from "@/core/services/acr.service";
import JwtService from "@/core/services/jwt.service";

//components
import DialogRegister from "./DialogRegister"
import DialogSelectionPerson from "./DialogSelectionPerson"

import {
    ADD_BODY_CLASSNAME,
    REMOVE_BODY_CLASSNAME
} from "@/store/htmlclass.module.js";

export default {
    name: "DetalleEvento",
    components: {
        DialogRegister,
        DialogSelectionPerson
    },
    data: () => ({
        title: 'deportista',
        activeItem: 'tab1',
        eventInfo: {},
        record_type: 'DE',
        open_dialog_selection: false,
        open_dialog_register: false,
        open_dialog_finalizar: false,
        personInfo: {},
        personasList: [],
        documentList: [],
        headers: {
            Authorization: `Bearer ${JwtService.getToken()}`
        },
        slug: null
    }),
    computed: {
        ...mapGetters(['oficialType'])
    },
    methods: {
        isActive(menuItem) {
            return this.activeItem === menuItem
        },
        setActive(menuItem) {
            this.activeItem = menuItem
            if (menuItem === 'tab1') {
                 this.record_type = 'DE'
                this.listParticipantes();
               
            }

            if (menuItem === 'tab2'){
                if (this.oficialType.length > 0) {
                    this.record_type = this.oficialType[0].id;
                }
                 this.listParticipantes();

            }
               

            if (menuItem == 'tab3')
                this.getMultimedia();

        },
        async getEvent(slug) {
            //console.log(slug)
            this.$store.dispatch(ADD_BODY_CLASSNAME, "page-loading");
            await evntsService.get({
                type: 'slug',
                slug: slug
            }).then((res) => {
                this.eventInfo = res.data
                this.listParticipantes()
                //console.log(res.data)
            }).catch((err) => {
                this.$store.dispatch(REMOVE_BODY_CLASSNAME, "page-loading")
                code.Manager(error.response)
            }).finally(() => {
                this.$store.dispatch(REMOVE_BODY_CLASSNAME, "page-loading")
            })
        },
        openDialogSelection() {
            if (this.record_type != '')
                this.open_dialog_selection = true
            else
                this.$message.error({
                    showClose: true,
                    message: 'Falta seleccionar el tipo de registro'
                })
        },
        openDialogRegister(data) {
            //console.log(data)
            this.personInfo = data
            this.open_dialog_selection = false
            this.open_dialog_register = true
        },
        async listParticipantes() {
            
            this.personasList = []
            this.$store.dispatch(ADD_BODY_CLASSNAME, "page-loading");
            await acrService.getList({
                record_type: this.record_type,
                idevent: this.eventInfo.idevent
            }).then((res) => {
                this.personasList = res.data
            }).catch((error) => {
                this.$store.dispatch(REMOVE_BODY_CLASSNAME, "page-loading")
                this.$message.error({
                    showClose: true,
                    message: 'Lo sentimos, se ha producido un error en la carga de información.'
                })
            }).finally(() => {
                this.$store.dispatch(REMOVE_BODY_CLASSNAME, "page-loading")
            })
        },
        async getMultimedia() {
            this.documentList = []
           // this.documentList.push({name: 'BASES GENERALES', ruta: ''}, {name: 'PROTOCOLO DE BIOSEGURIDAD', ruta: ''})
           this.$store.dispatch(ADD_BODY_CLASSNAME, "page-loading");
            await acrService.getMultimedia(this.eventInfo).then((res) => {
                this.documentList = res.data
            }).catch((error) => {
                this.$store.dispatch(REMOVE_BODY_CLASSNAME, "page-loading")
                this.$message.error({
                    showClose: true,
                    message: 'Lo sentimos, se ha producido un error en la carga de información.'
                })
            }).finally(() => {
                this.$store.dispatch(REMOVE_BODY_CLASSNAME, "page-loading")
            })
        },
        eddiItem(data) {
            this.openDialogRegister(data)
        },
        deleteItem(data) {
            this.$confirm('Desea eliminar la participación de ' + data.firstname + '?', 'Aviso', {
                confirmButtonText: 'OK',
                cancelButtonText: 'Cancel',
                type: 'warning'
            }).then(() => {
                this.onDelete(data)
            })
        },
        async onDelete(data){
            this.$store.dispatch(ADD_BODY_CLASSNAME, "page-loading");
            await acrService.delete(data).then((res) => {
                if(res.data.status)
                    this.listParticipantes()
                else
                    this.$message.error({ showClose: true, message: res.data.message })
            }).catch((err) => {
                this.$store.dispatch(REMOVE_BODY_CLASSNAME, "page-loading")
                code.Manager(err.response)
            }).finally(() => {
                this.$store.dispatch(REMOVE_BODY_CLASSNAME, "page-loading")
            })
        },
        openDialogFinalizar() {
            this.open_dialog_finalizar = true
        },
        onClose() {
            this.open_dialog_finalizar = false
        },
        FilbeforeAvatarUpload(file) {
            
            const isIMAGE = (file.type === 'image/jpeg' || file.type === 'image/png' || file.type === 'image/jpg' || file.type === 'application/pdf');

            if (!isIMAGE) {
                this.$message.error('Formato de archivo no admitido!');
                return false;
            }
            return true;
        },
        FilhandleAvatarSuccess(res, file) {
            this.$message({
                message: res.message,
                type: 'success'
            })
            this.listParticipantes()
        },
        FilhandleAvatarError(err, file) {
            const e = JSON.parse(err.message);
            this.$alert(e.messages.error, 'Error ' + e.error, {
                type: 'warning'
            });
        },
        downloadConsolidate(){
            if(this.eventInfo !=null)
                window.open(process.env.VUE_APP_URL_BACKEND + `pdf/consolidate/${window.btoa(this.eventInfo.idevent)}/${JwtService.getToken()}`, '_blank');
            else 
                alert('No se ha recepcionado el evento');
                

        }
    },
    created() {
        this.slug = this.$route.params.slug
        this.getEvent(this.slug)
        //this.listParticipantes()
        
    }
}
</script>
